module.exports = __webpack_public_path__ + "img/IMG_1995.50af4053.jpg";